const enum UserPrivilege {
  AGENT_CREATE = 'AGENT_CREATE',
  AGENT_VIEW = 'AGENT_VIEW',
  AGENT_INTERACT = 'AGENT_INTERACT',
  AGENT_EDIT = 'AGENT_EDIT',
  AGENT_DELETE = 'AGENT_DELETE',
  AGENT_INSTALL = 'AGENT_INSTALL',
  AGENT_VIEW_LOGS = 'AGENT_VIEW_LOGS',
  CONTROL_PLANE_ADMIN = 'CONTROL_PLANE_ADMIN',
  CONTROL_PLANE_USER = 'CONTROL_PLANE_USER',
}

export default UserPrivilege;
